import { defineRecipe } from "@chakra-ui/react"

// Chakra paints a pulsing skeleton with bg.emphasized, which in dark mode is all but the card's
// own colour, so loading placeholders vanish. The `skeleton` token keeps light mode as it was.
// Merged into Chakra's own skeleton recipe; only the pulse colour changes.
const skeleton = defineRecipe({
  variants: {
    variant: {
      pulse: {
        background: "skeleton",
      },
    },
  },
})

export default skeleton
